import { TRESPONSE_ATTACHMENT_APPROVAL_LIST, TRESPONSE_ATTACHMENT_LIST } from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export interface TAttachmentState {
  attachmentApprovalsListing: null | TRESPONSE_ATTACHMENT_APPROVAL_LIST;
  attachmentListing: null | TRESPONSE_ATTACHMENT_LIST;
  attachmentListingPagination: TUserPaginationOption;
  attachmentListingSearchStr: string;
}

export const ATTACHMENTS_ITEMS_PER_PAGE_LIST = [10, 50, 100, 150, 200];
export const ATTACHMENT_DEFAULT_PAGINATION_OPTION: TUserPaginationOption = { pageNo: 1, pageSize: 10 };
export const ATTACHMENT_APPROVAL_ITEMS_PER_PAGE_LIST = [10, 20, 50, 100];

export const TAttachmentActionTypes = {
  FetchAttachmentList: 'FETCH_ATTACHMENT_LIST' as const,
  FetchAttachmentListSuccess: 'FETCH_ATTACHMENT_LIST_SUCCESS' as const,
  FetchAttachmentListFailure: 'FETCH_ATTACHMENT_LIST_FAILURE' as const,
  FetchAttachmentApprovalList: 'FETCH_ATTACHMENT_APPROVAL_LIST' as const,
  FetchAttachmentApprovalListSuccess: 'FETCH_ATTACHMENT_APPROVAL_LIST_SUCCESS' as const,
  FetchAttachmentApprovalListFailure: 'FETCH_ATTACHMENT_APPROVAL_LIST_FAILURE' as const,
  SetAttachmentListingPaginationOption: 'SET_ATTACHMENT_LISTING_PAGINATION_OPTION' as const,
  SetAttachmentListingSearchStr: 'SET_ATTACHMENT_LISTING_SEARCH_STR' as const,
};
